module.exports = __webpack_public_path__ + "static/media/icon-404.aa357102.svg";